<div *ngIf='formReady' class='update-pipelines'>
  <form [formGroup]='inputForm'>
    <div class='row'>
      <div class='col-12'>
        <mat-label>Product:</mat-label>
        <app-select
        placeholder="Select product"
        label="Select product"
        formControlName="user_product_id"
        (selection)="onChangeSelect($event, 'user_product_id')"
        [items]="getProductItems()"
        ></app-select>
      </div>
    </div>
    <div class='row mt-3'>
      <div class='col-12'>
        <mat-label>Status:</mat-label>
        <app-select
          label="Select status"
          formControlName="status"
          (selection)="onChangeSelect($event, 'status')"
          [items]="getAssociatedProductItems()"
        ></app-select>
      </div>
    </div>

      <div *ngIf="action == 'update' && status > 0" class='row mt-3'>
        <div class="col col-12">
          <mat-label>Actual value :</mat-label>
          <app-text-field
            formControlName='actual_value'
            placeholder='Actual value'
            type='text'></app-text-field>
      </div>
    </div>

      <div *ngIf="action == 'update' && status < 2" class='row mt-3'>
        <div class="col col-12">
          <mat-label>Estimated value :</mat-label>
          <app-text-field
            formControlName='estimated_value'
            placeholder='Estimated value'
            type='text'
          ></app-text-field>
        </div>
      </div>
      <div *ngIf="action == 'update' && status === 2" class='row mt-3'>
        <div class="col col-12">
          <mat-label>Lost reason :</mat-label>

          <app-text-field
            formControlName='lost_reason'
            placeholder='Lost reason'
            type='text'
          ></app-text-field>
      </div>
    </div>

      <div *ngIf="action == 'update'" class='row mt-3'>
        <div class="col col-12">
          <div>Description:</div>
          <app-editor formControlName='description'></app-editor>
        </div>
      </div>

      <div *ngIf="action == 'update'" class='row mt-3'>
        <div class="col col-12">
          <div>Estimated closing date:</div>
          <app-text-field
                  datePickerType='calendar'
                  formControlName='estimated_date'
                  placeholder='Date'
                  type='date'></app-text-field>
        </div>
      </div>

      <div *ngIf="action == 'update'" class='row mt-3'>
        <div class="col col-12">
          <div>Status date:</div>
          <app-text-field
                  datePickerType='calendar'
                  formControlName='status_date'
                  placeholder='Date'
                  type='date'></app-text-field>
        </div>
      </div>

      <div *ngIf="action == 'update' && status === 1" class='row mt-3'>
        <div class="col col-12">
          <div>Renewal date:</div>
           <app-text-field
                  datePickerType='calendar'
                  formControlName='renewal_date'
                  placeholder='Date'
                  type='date'></app-text-field>
        </div>
      </div>

      <div *ngIf="action == 'update'" class='row mt-3'>
        <div class="col col-12">
            <mat-label>Pipeline :</mat-label>
            <app-select
            label="Select pipeline"
            formControlName="pipeline"
            (selection)="onChangeSelect($event, 'pipeline')"
            [items]="getPipelineItems()"
            ></app-select>
        </div>
      </div>
  </form>
</div>
